import { Select, SelectItem } from '@heroui/react'
import { useQuery } from '@tanstack/react-query'
import { forwardRef } from 'react'
import { TbBrandTwilio } from 'react-icons/tb'
import { $fetch } from 'utils/fetch'

const PoolSelect = forwardRef(({ value, ...props }, ref) => {
  const { data: encryptedKeys, isLoading: encryptedKeysLoading } = useQuery({
    queryKey: ['encryptedKeys'],
    queryFn: async () => {
      const { data } = await $fetch('/byot/get_keys')
      return data?.map(key => key.id)
    },
    staleTime: Infinity,
  })

  return (
    <Select
      label="Dialer Pool"
      labelPlacement="outside"
      isLoading={encryptedKeysLoading}
      description="Select a BYOT connection to use as your dialer pool."
      placeholder="Select an encrypted key..."
      variant="bordered"
      startContent={<TbBrandTwilio className="text-lg text-red-500 opacity-50" />}
      radius="sm"
      selectedKeys={value && [value]}
      {...props}
      ref={ref}
    >
      {encryptedKeys?.map(key => (
        <SelectItem
          key={key}
          startContent={(
            <TbBrandTwilio className="text-lg text-red-500 opacity-50" />
          )}
          textValue={key}
        >
          <p className="font-geist-mono text-xs">
            {key}
          </p>
        </SelectItem>
      ))}
    </Select>
  )
})

export default PoolSelect
